import React, { useState, useEffect } from "react";

import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import APIService from "../../../../services/apiAxiosService.js";
import useHttp from "../../../../hooks/useHttp.js";

const PdfGeneratorReport = (row,reportDetails,reportDetailsCount) => {
  const org = sessionStorage.getItem("org_name");
  var fiscalyear = "";
  var today = new Date();
  var fiscalyear = today.getFullYear();
  let day = today.getDate();
  let month = today.toLocaleString("default", { month: "long" });
  let currentDate = `${day}-${month}-${fiscalyear}`;

 

  const pdf = new jsPDF("p", "pt", "a4");
  pdf.setFont("Arial", "normal");
  pdf.setFontSize(8);
  pdf.setTextColor(0, 0, 0);

  pdf.text(500, 50, "Private and confidential  ");

   pdf.setDrawColor(139, 0, 0);

  pdf.line(20, 55, 580, 55);
  var width = pdf.internal.pageSize.getWidth();
  var height = pdf.internal.pageSize.getHeight();

  var widthImage = 210;
  var heightImage = 200;

  const img = sessionStorage.getItem("image");
  pdf.addImage(img, "JPEG", 190, 50, widthImage, heightImage);

  pdf.setFont("Georgia (Headings)", "bold");
  pdf.setFontSize(26);
  pdf.setTextColor(0, 0, 0);

  pdf.text(150, 280, "Third Party Risk Assessment ");

  pdf.setFont("Georgia (Headings)", "bold");
  pdf.setFontSize(26);
  pdf.setTextColor(0, 0, 0);

  pdf.text(215, 310, "Programme -" + fiscalyear);

  pdf.setFont("Georgia (Body)", "normal");
  pdf.setFontSize(22);
  pdf.setTextColor(0, 0, 0);

   const textData="Conducted by PwC Services LLP for " + org;


var splitTitleDetails = pdf.splitTextToSize(textData, 450);
  pdf.text(300, 350, splitTitleDetails, { align: 'center'});


  pdf.setFont("Georgia (Body)", "normal");
  pdf.setFontSize(22);
  pdf.setTextColor(0, 0, 0);

  pdf.text(170, 620, "Date of the report:  " + currentDate);

  pdf.setFont("Arial", "normal");
  pdf.setFontSize(8);
  pdf.setTextColor(0, 0, 0);

  pdf.text(30, 800, "Name of client  " + org);

  pdf.setFont("Arial", "normal");
  pdf.setFontSize(8);
  pdf.setTextColor(0, 0, 0);

  pdf.text(250, 800, "Strictly private and confidential");

  pdf.setFont("Arial", "normal");
  pdf.setFontSize(8);
  pdf.setTextColor(0, 0, 0);

  pdf.text(500, 800, "May " +fiscalyear);

  pdf.setFont("Arial", "normal");
  pdf.setFontSize(8);
  pdf.setTextColor(0, 0, 0);

  pdf.text(530, 810, '1');

  pdf.addPage("p", "mm", "a4");

 

  pdf.setFont("Georgia (Headings)",  "bold");
  pdf.setTextColor(139, 0, 0);
  pdf.setFontSize(16);
  pdf.text(30, 85, "1.1. Introduction");

  pdf.setFont("Georgia (Headings)", "normal");
  pdf.setTextColor(0, 0, 0);
  pdf.setFontSize(10.5);

  var pdfText7 = `The Third-Party Risk Assessment initiated by ${org} is a part of the yearly cybersecurity posture assessment of its vendor ecosystem. As a part of this assessment, there were 100 questions which were administered to you. The assessment has been designed in a manner to achieve a very objective basis to understand the vendor cyber security posture.`;
  var splitTitle = pdf.splitTextToSize(pdfText7, 550);
  pdf.text(60, 100, splitTitle);

  var pdfText8 = "The questionnaire details as under:";
  pdf.text(60, 140, pdfText8);

const report=reportDetails?.map((val,i)=>[
val.areadetails,
val.closurestatus
])
  // generate auto table with body
  var y = 10;
  pdf.setLineWidth(2);
  pdf.text(10, (y = y + 30), "");
  pdf.autoTable({
    head:[["Sections", "Question Count"]],
     body: report,
    styles: { halign: "left", font: "Georgia", fontSize: 11 },
    startY: 160,
    theme: "grid",
    headStyles: { fillColor:'rgb(139, 0, 0)',textColor:'#fff',fontStyle:'bold' },

   
  });

  


  pdf.setFont("Georgia (Headings)",  "bold");
  pdf.setTextColor(139, 0, 0);
  pdf.setFontSize(16);
  pdf.text(30, 365, "1.2. Assessment Summary");

  const data1=reportDetailsCount?.map((val,i)=>[
val.areadetails,
val.yes,
val.no,
val.na,

  ]
    )
    const sumOfYes = reportDetailsCount.reduce((acc , val)=>{
      return acc + parseInt(val.yes);
   } ,0);
   const sumOfNo = reportDetailsCount.reduce((acc , val)=>{
    return acc + parseInt(val.no);
 } ,0);
 const sumOfNa = reportDetailsCount.reduce((acc , val)=>{
  return acc + parseInt(val.na);
} ,0);
   

    var body = [...reportDetailsCount.map(el => [el.areadetails,el.yes,el.no,el.na]), 
    [{content: `Total`},`${sumOfYes}`,`${sumOfNo}`,`${sumOfNa}`, 
    ]]
  // generate auto table with body
  var y = 10;
  pdf.setLineWidth(2);
  pdf.text(10, (y = y + 30), "");
  pdf.autoTable({
    head:[["Sections", "Yes", "No", "NA"]],
     body: body,
     styles: { halign: "left", font: "Georgia", fontSize: 11 },
    startY: 385,
    theme: "grid",
    headStyles: { fillColor:'rgb(139, 0, 0)',textColor:'#fff',fontStyle:'bold' },
    showHead: "everyPage",
    didDrawPage: function (data) {

      pdf.setFont("Arial", "normal");
      pdf.setFontSize(8);
      pdf.setTextColor(0, 0, 0);
    
      pdf.text(500, 30, "Private and confidential  ");
    
       pdf.setDrawColor(139, 0, 0);
    
      pdf.line(20, 35, 580, 35);
  

    }
   
  });
  // // save the data to this file
  pdf.setFont("Georgia (Headings)",  "bold");
  pdf.setTextColor(139, 0, 0);
  pdf.setFontSize(16);
  pdf.text(30, 600, "1.3. Rating Scale");

  var body = [
    ["95-100", "Satisfactory"],
    ["85-94", "Partially Satisfactory"],
    ["0-84", "Needs Improvement"],
  ];
  // generate auto table with body
  var y = 10;
  pdf.setLineWidth(2);
  pdf.text(20, (y = y + 30), "");
  pdf.autoTable({
    head: [['Scale', 'Rating']],
    body: body,
    styles: { halign: "left", font: "Georgia", fontSize: 11 },
    startY: 620,
    theme: "grid",
    headStyles: { fillColor:'rgb(139, 0, 0)',textColor:'#fff',fontStyle:'bold' },

  });
  
  // save the data to this file
  pdf.setFont("Georgia (Headings)",  "bold");

  pdf.setFont("Arial", "normal");
  pdf.setFontSize(8);
  pdf.setTextColor(0, 0, 0);

  pdf.text(30, 800, "Name of client  " + org);

  pdf.setFont("Arial", "normal");
  pdf.setFontSize(8);
  pdf.setTextColor(0, 0, 0);

  pdf.text(250, 800, "Strictly private and confidential");

  pdf.setFont("Arial", "normal");
  pdf.setFontSize(8);
  pdf.setTextColor(0, 0, 0);

  pdf.text(500, 800, "May " +fiscalyear);
  pdf.text(530, 810, '2');

  pdf.addPage("p", "mm", "a4");

  pdf.setFont("Arial", "normal");
  pdf.setFontSize(8);
  pdf.setTextColor(0, 0, 0);

  pdf.text(500, 50, "Private and confidential  ");

   pdf.setDrawColor(139, 0, 0);

  pdf.line(20, 55, 580, 55);

  
  pdf.setFont("Georgia (Headings)",  "bold");
  pdf.setTextColor(139, 0, 0);
  pdf.setFontSize(16);
  pdf.text(30, 85, "1.4. Conclusion");

  pdf.setFont("Georgia (Headings)", "normal");
  pdf.setTextColor(0, 0, 0);
  pdf.setFontSize(10.5);

  var pdfText9 = `Thanking you for taking your time out for completing this assessment. Your responses are indeed valuable to us as together we have embarked upon our journey through collaboration and partnership to grow our individual business.`;

  var splitTitle1 = pdf.splitTextToSize(pdfText9, 500);
  pdf.text(60, 100, splitTitle1);

  pdf.setFont("Georgia (Headings)", "normal");
  pdf.setTextColor(0, 0, 0);
  pdf.setFontSize(10.5);

 

  var pdfText10 = `A cybersecure work environment helps to deliver better customer confidence and trust.`;
  var splitTitle2 = pdf.splitTextToSize(pdfText10, 550);
  pdf.text(60, 125, splitTitle2);

  var pdfText11 = `A trusted and confident business partnership means a safe and a secure driving experience.`;
  var splitTitle3 = pdf.splitTextToSize(pdfText11, 550);
  pdf.text(60, 140, splitTitle3);

  var pdfText12 = `You have completed the assessment and shared your responses with the ${org} Team for review and inputs.`;
  var splitTitle3 = pdf.splitTextToSize(pdfText12, 550);
  pdf.text(60,160, splitTitle3);

  var pdfText13 = `The ${org} Team shall review the responses shared and will request for closure for the questions via a mail request. Requesting you to complete the responses to every mail request at the soonest. Please share your feedback about your participation to tprm@tatamotors.com.`;
  var splitTitle4 = pdf.splitTextToSize(pdfText13, 500);
  pdf.text(60, 180, splitTitle4);


  var pdfText14 = `We shall certainly incorporate your suggestions where feasible in our assessment cycle next year.`;
  var splitTitle5 = pdf.splitTextToSize(pdfText14, 550);
  pdf.text(60,220, splitTitle5);


  var pdfText15 = `Together we shall build a SAFER and SECURE world.`;
  var splitTitle6 = pdf.splitTextToSize(pdfText15, 550);
  pdf.text(60,240, splitTitle6);

  pdf.setFont("Arial", "normal");
  pdf.setFontSize(8);
  pdf.setTextColor(0, 0, 0);

  pdf.text(30, 800, "Name of client  " + org);

  pdf.setFont("Arial", "normal");
  pdf.setFontSize(8);
  pdf.setTextColor(0, 0, 0);

  pdf.text(250, 800, "Strictly private and confidential");

  pdf.setFont("Arial", "normal");
  pdf.setFontSize(8);
  pdf.setTextColor(0, 0, 0);

  pdf.text(500, 800, "May " +fiscalyear);
  pdf.text(530, 810, '3');

  pdf.addPage("p", "mm", "a4");
  pdf.setFillColor(139, 0, 0);

  pdf.rect(
    10,
    55,
    pdf.internal.pageSize.width - 7,
    pdf.internal.pageSize.height - 60,
    "F"
  ); // draw a border in pdf
  pdf.setTextColor(255, 255, 255);
  pdf.setFont("Georgia (Body)", "italic", "bold");
  pdf.setFontSize(20);
  pdf.text(200, 300, "End of Report");

  pdf.setTextColor(255, 255, 255);
  pdf.setFont("Georgia (Body)", "normal");
  pdf.setFontSize(10);
  pdf.text(
    50,
    760,
    "© Copyright, Confidential, Tata Motors Limited"
  );

  pdf.save(`${row.vendor_name}.pdf`); // will save the file in the current working directory
};

export default PdfGeneratorReport;
